import { Button } from "@repo/ui";

type Props = {
  pendingChangesCount: number;
  onCancelAllClick: () => void;
  onSaveAllChanges: () => void;
  isSaving: boolean;
};

export const ItemPendingChangesActions = ({
  pendingChangesCount,
  onCancelAllClick,
  onSaveAllChanges,
  isSaving,
}: Props) => {
  return (
    <div className="border-gxe-border sticky bottom-0 mt-5 flex items-center justify-end gap-2 bg-white px-4 py-3 shadow-lg ring-1 ring-black/5">
      <span className="mr-auto text-sm text-gray-600">{pendingChangesCount} unsaved change(s)</span>
      <Button data-allow-navigation onClick={onCancelAllClick} variant="outline" size="sm">
        Cancel
      </Button>
      <Button
        data-allow-navigation
        onClick={onSaveAllChanges}
        variant="primary"
        size="sm"
        disabled={isSaving}
      >
        {isSaving ? "Saving..." : "Save Changes"}
      </Button>
    </div>
  );
};
